import { hasNonEmptyValue } from 'Lib/Any';
import React from 'react';
import { ListItemModel } from '../../../../Data/ViewModels/ListItemModel';
import { CreatableDropdown, Dropdown, Field, IMessageProps, TextInput } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from '../../../Layout';

interface IWorksheetExternalTestSectionProps {
  name: string;
  externalTestResults?: any;
  permitOtherTestMethods?: boolean;
  messages?: IMessageProps[];
  testMethods?: ListItemModel[];
}

let WorksheetExternalTestSection: React.FC<IWorksheetExternalTestSectionProps> = ({
  name,
  externalTestResults,
  testMethods,
  messages,
  permitOtherTestMethods,
}) => (
  <>
    <ListFieldSection>
      <FieldSet>
        <Field input={<TextInput />} label="Source" name={`${name}.Source`} maxLength={50} />
        <Field
          input={permitOtherTestMethods ? <CreatableDropdown /> : <Dropdown />}
          label="Test Method"
          placeholder="Select test method..."
          name={`${name}.Method`}
          formatCreateLabel={(label: string) => `Other method: ${label}`}
          options={testMethods}
          simpleValue={true}
          maxLength={50}
        />
      </FieldSet>
    </ListFieldSection>
    {externalTestResults}
    {/* Shows all messages attached to the ExternalTest 
      Visible property set which shortens the length of the field if no messages are set */}
    <ListFieldSection visible={hasNonEmptyValue(messages)} messages={messages}></ListFieldSection>
  </>
);

WorksheetExternalTestSection = withInjectedProps(WorksheetExternalTestSection);

export default WorksheetExternalTestSection;
export type { IWorksheetExternalTestSectionProps };
